import app from "@/common/plugins/vueInstance";
import { createI18n } from "vue-i18n";
import pt from "@/common/locales/ptBR";
import en from "@/common/locales/enUS";

const messages = {
  pt,
  en,
};

const i18n = createI18n({
  legacy: false,
  locale: "pt",
  fallbackLocale: "pt",
  globalInjection: true,
  messages,
});

app.use(i18n);
